export const GRADES = [
  "Kindergarten",
  "Grade 1",
  "Grade 2",
  "Grade 3",
  "Grade 4",
  "Grade 5",
  "Grade 6",
  "Grade 7",
  "Grade 8",
  "Grade 9",
  "Grade 10",
  "Grade 11",
  "Grade 12",
] as const;
export type Grade = (typeof GRADES)[number];

export const SECONDARY_GRADES: readonly Grade[] = ["Grade 7", "Grade 8", "Grade 9", "Grade 10", "Grade 11", "Grade 12"];

// HAR 8-12-18 asks for a nationally normed test score in these grades only.
// The annual progress report is due in every grade. Keep the two distinct.
export const TEST_GRADES: readonly Grade[] = ["Grade 3", "Grade 5", "Grade 8", "Grade 10"];

export const ELEMENTARY_SUBJECTS = [
  "Language arts",
  "Math",
  "Social studies",
  "Science",
  "Art",
  "Music",
  "Health",
  "PE",
] as const;

export const SECONDARY_SUBJECTS = ["English", "Math", "Social studies", "Science", "Health", "PE", "Guidance"] as const;

export function subjectsFor(grade: Grade | ""): readonly string[] {
  return grade !== "" && SECONDARY_GRADES.includes(grade) ? SECONDARY_SUBJECTS : ELEMENTARY_SUBJECTS;
}

export type Enrollment = "hi-public" | "private" | "out-of-state" | "never-enrolled";

export interface Child {
  id: string;
  firstName: string;
  /** Full legal name. Asked only at the legal step, because the notice requires it. */
  legalName: string;
  /** ISO date, yyyy-mm-dd. */
  birthdate: string;
  grade: Grade | "";
  /** Optional. What the child is into right now, in the parent's words. */
  interests: string;
}

export interface Intake {
  parentName: string;
  parentEmail: string;
  parentPhone: string;
  address: string;
  children: Child[];
  enrollment: Enrollment | "";
  schoolOfRecord: string;
  principal: string;
  /** ISO date the home school program begins. */
  startDate: string;
  whyNow: string;
  worry: string;
}

export interface Entry {
  id: string;
  childId: string;
  /** Epoch milliseconds. */
  ts: number;
  text: string;
  subjects: string[];
  minutes: number;
  photo?: string;
  stuck?: boolean;
  askGuide?: boolean;
  example?: boolean;
}

export interface Material {
  title: string;
  author: string;
  publisher: string;
  year: string;
}

export interface Program {
  mastery: string;
  /** ISO dates bounding the program year. */
  from: string;
  to: string;
  materials: Material[];
}

export interface Message {
  id: string;
  ts: number;
  from: "parent" | "guide";
  text: string;
  answeredAt?: number;
}

export type MasteryState = "exploring" | "practicing" | "fluent";

export const MASTERY_DEFINITIONS: Record<MasteryState, string> = {
  exploring: "Exploring. Curiosity is up. Gathering information and asking questions.",
  practicing: "Practicing. Doing the work, hitting friction, and trying again.",
  fluent: "Fluent. Can do it from scratch and can explain it to someone else.",
};

export type BlobKind = "intake" | "entry" | "program" | "message" | "summary";

export interface SealedBlob {
  iv: string;
  ciphertext: string;
}

export interface Grant {
  ephemeralPublicKey: JsonWebKey;
  iv: string;
  wrappedKey: string;
}
